import React from "react"

import Task from "../../../../model2/task/task"
import ActionEntity from "../../../../model2/automation/action-entity/action-entity"
import PopoverMenuOption from "../../../../gd-components/popover-menu/popover-menu/menu-option"
import PopoverMenuSeparator from "../../../../gd-components/popover-menu/popover-menu/popover-menu-separator"
import VScroll from "../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import ControlButtonStandard, {ControlButtonType} from "../../../../gd-components/buttons/control-button/control-button-standard"
import {ControlButtonSize} from "../../../../gd-components/buttons/control-button/@types"
import {taskMore_getAvailableActions, taskMore_runAction} from "./run-action"
import {Actions_AddPopoverMenuOption} from "../../../../model2/action/func/add-menu-item";

type Props = {
    menuParams  : {
        task            : Task
        hidePopover?    : callback
    }
}

// Nested popover for the "Actions" menu option - runs an action via the same
// call TaskView uses, showing the app busy overlay while it runs.
export default function TaskMore_ActionsPopoverMenu(props: Props) {

    const task              = props.menuParams.task
    const availableActions  = taskMore_getAvailableActions(task)
    const canAddAction      = gd.ac.check.createAutomation() && gd.ac.check.automation.enabled()

    const onClickAction = async (automation: ActionEntity) => {
        props.menuParams.hidePopover?.()

        await gd.layout.loading.showAppBusyAsync()

        try {
            await taskMore_runAction(task, automation)
        } finally {
            gd.layout.loading.hide()
        }

        return
    }

    const onClickEditAction = (automation: ActionEntity, e: React.SyntheticEvent) => {
        e.stopPropagation()
        props.menuParams.hidePopover?.()
        gd.goTo('action/{0}'.f(automation.id))

        return
    }

    // const onClickAddAction = () => {
    //     props.menuParams.hidePopover?.()
    //
    //     if (task.projectId) {
    //         gd.tempParamsStorage.add('automationProjectId', task.projectId)
    //     }
    //
    //     gd.goTo('action/new')
    //
    //     return
    // }

    return (
        <div className="ui5-popover-menu min-w-200">
            <VScroll containerClass="max-h-200">
                {_.map(availableActions, (automation: ActionEntity, key) => {

                    // const canEditAction = gd.ac.check.automation.edit(automation.scope.projectId)

                    return (
                        <PopoverMenuOption
                            key     = {key}
                            option  = {{
                                icon    : 'ii5-lightning',
                                label   : automation.name,
                                onClick : () => onClickAction(automation),
                            }}
                        >
                            {/*{canEditAction &&
                                <div className="right-block">
                                    <ControlButtonStandard
                                        type    = {ControlButtonType.EDIT}
                                        size    = {ControlButtonSize.SIZE_24}
                                        hint    = "Edit action"
                                        onClick = {(e: React.SyntheticEvent) => onClickEditAction(automation, e)}
                                    />
                                </div>}*/}
                        </PopoverMenuOption>
                    )
                })}

                {canAddAction && !_.isEmpty(availableActions) &&
                    <PopoverMenuSeparator/>
                }

                {canAddAction &&
                    <PopoverMenuOption
                        option = {Actions_AddPopoverMenuOption(task.projectId)}
                    />
                }
            </VScroll>
        </div>
    )
}
